import {tagPath} from '@app/[lang]/(common-header-footer)/tags/constants'

export const DEFAULT_PROPERTY_CODE = 'cfuucl7YgA'

export const GAMEPLAYER_ROUTE = 'game'

export const fallbackPlaySubdomain = 'https://ugnyn1mfq.play.gamezop.com'

export const i18nRoutes = [
  '/',
  `/game/*gameParams`,
  `/${tagPath}*tagParams`,
  `/games`,
  '/intro',
  '/login',
  '/incorrect-property-id',
  '/my-favourites',
]

export const gamezopOGImage = 'https://static.gamezop.com/logo/gamezop-play-meta-2.jpg'

export const USER_JOURNEY_GROUP = '2025-preload-games'
